module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Opis</label>\n    </dt>\n    <dd>\n        <textarea\n            ng-class=\"IssueFormDescriptionCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"description\"\n            ng-model=\"IssueFormDescriptionCtrl.description\"\n        ></textarea>\n    </dd>\n    <dd>\n        <span>Prosimy o niezamieszczanie danych osobowych w opisie.</span>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/description/issue_form_description.html
// module id = 671
// module chunks = 0